import React from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import classNames from 'classnames';
import isFunction from 'lodash/isFunction';
import Analytics from '../../utils/Analytics';
import { SegmentEventTypes } from '../../data/tracking';
import LabelWrapper from '../LabelWrapper.component';

export const WrappedInputTextarea = props => {
	const { className, isInputInvalid, dataqa = 'common', onFocus, onBlur, ...config } = props;

	const inputTextClassName = classNames(className, {
		'invalid-component': isInputInvalid,
	});

	const focusHandler = e => {
		Analytics.trackSegmentEvent({
			trackingData: {
				field_type: 'textarea',
				field_name_dataqa: `ui-textarea-${dataqa}`,
			},
			eventType: SegmentEventTypes.UserInputStarted,
		});

		if (isFunction(onFocus)) {
			onFocus(e);
		}
	};

	const blurHandler = e => {
		Analytics.trackSegmentInputEvent({
			trackingData: {
				field_type: 'textarea',
				field_name_dataqa: `ui-textarea-${dataqa}`,
			},
			eventType: SegmentEventTypes.UserInputCompleted,
			fieldValue: e.target?.value,
		});

		if (isFunction(onBlur)) {
			onBlur(e);
		}
	};

	return (
		<div className="common-ui-textarea">
			<InputTextarea
				className={inputTextClassName}
				data-qa={`ui-textarea-${dataqa}`}
				dataqa={`ui-textarea-${dataqa}`}
				onFocus={focusHandler}
				onBlur={blurHandler}
				{...config}
			/>
		</div>
	);
};

export const WrappedInputTextareaWithLabel = LabelWrapper(WrappedInputTextarea);
